<template>
  <div>
    <button
      class="text-slate-600 dark:text-slate-100 w-10 h-10 my-2 flex items-center justify-center rounded-lg hover:bg-slate-25 dark:hover:bg-slate-700 dark:hover:text-slate-100 hover:text-slate-600 relative"
      :class="{
        'bg-woot-50 dark:bg-slate-800 text-woot-500 hover:bg-woot-50':
          isActive,
      }"
      @click="toBroadcastManagement"
      v-tooltip.right="$t('SIDEBAR.BROADCASTS')"
    >
      <fluent-icon
        icon="send"
        :class="{
          'text-woot-500': isActive,
        }"
      />
      <span
        v-if="unreadCount"
        class="text-black-900 bg-yellow-300 absolute -top-0.5 -right-1 p-1 text-xxs min-w-[1rem] rounded-full"
      >
        {{ unreadCount }}
      </span>
    </button>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      unread_count: 'broadcastsView/getUnreadCount',
    }),
    unreadCount() {
      if (!this.unread_count.unread_count) {
        return '';
      }

      return this.unread_count.unread_count < 100
        ? `${this.unread_count.unread_count}`
        : '99+';
    },
    isActive() {
      return this.$route.name === 'broadcasts_index';
    },
  },
  methods: {
    toBroadcastManagement() {
      if (this.$route.name !== 'broadcasts_index') {
        this.$router.push({
          name: 'broadcasts_index',
          params: { accountId: this.accountId },
        });
      }
    },
    async getUnreadCount() {
      await this.$store.dispatch('broadcastsView/getUnreadCount');
    },
  },
  mounted() {
    this.getUnreadCount();
  },
};
</script>
